<template>
	<div>
		<h4>Здорово!</h4>
		<p>Здесь поздравления и финальный текст</p>
	</div>
</template>

<script>
  export default {
    name: "finish",
    data() {
      return {}
    },
    props: {
      items: ''
    },
    methods: {}
  }
</script>

<style scoped>

</style>